import { OptionKey } from '@common-fe/common-fe';

import { EmailCommunicationType } from '@/modules/employer/types/Contact.types';

export interface CreateContactDto {
  organization_id: number;
  username?: string;
  password?: string;
  role_id: OptionKey;
  title?: string | null;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  department?: string | null;
  primary: boolean;
  external_identifier: string | null;
  contact_type: string;
  contact_status_type: string;
  email_communication_type_list: EmailCommunicationType[];
  job_function_types?: JubFunctionEnum[];
}

export enum JubFunctionEnum {
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
}

export interface ContactResponseModel {
  id: number;
  organization_id: number;
  title: string | null;
  job_function_types: JubFunctionEnum[];
  first_name: string;
  last_name: string;
  email: string;
  is_email_verified?: boolean;
  username?: string;
  phone: string | null;
  department: string | null;
  primary: boolean;
  external_identifier: string | null;
  contact_type: string;
  contact_status_type: string;
  role_id: OptionKey;
  roleId?: OptionKey;
  email_communication_type_list: EmailCommunicationType[];
}
